<script>
    import { sendAnalytics } from "@/core/SendAnalytics";
    import BaseInput from "@main/packages/BaseInput";

    export default {
        name: "SubscribeForm",
        components: {
            BaseInput,
        },
        data() {
            return {
                email: "",
                errorMessage: "",
                isSuccessSubmit: false,
                isSubmitted: false,
            };
        },
        methods: {
            clearError() {
                this.errorMessage = "";
            },
            onSubmit() {
                if (this.isSubmitted) {
                    return;
                }

                if (this.email.length < 1) {
                    this.errorMessage = "Поле обязательно для заполнения";
                    return;
                }

                this.isSubmitted = true;
                this.errorMessage = "";

                this.$store.formApi.subscribeTo({ email: this.email }).then((res) => {
                    if (res.error) {
                        this.errorMessage = "Неверный email";
                    } else {
                        this.isSuccessSubmit = true;
                        sendAnalytics.send(sendAnalytics.events.subscribe);
                    }
                });

                setTimeout(() => {
                    this.isSubmitted = false;
                }, 1200);
            },
        },
    };
</script>

<template>
    <div class="subscribe-form" :class="{ 'is-success': isSuccessSubmit }">
        <form class="subscribe-form__form" @submit.prevent="onSubmit">
            <base-input
                v-model="email"
                placeholder="Электронная почта"
                :error-text="errorMessage"
                @error="clearError"
            ></base-input>
            <button type="submit" class="subscribe-form__button outline">
                <img src="/static/xd-design/icons/email.svg" alt="" />
            </button>
        </form>

        <div class="subscribe-form__agreement">
            Нажимая на кнопку, вы даете согласие на обработку своих
            <a target="_blank" href="/document-personal">персональных данных</a>
        </div>
        <div class="subscribe-form__success">Подписка оформлена!</div>
    </div>
</template>

<style lang="scss">
    .subscribe-form {
        position: relative;
        &.is-success {
            .subscribe-form__form,
            .subscribe-form__agreement {
                opacity: 0;
            }
            .subscribe-form__success {
                opacity: 1;
                pointer-events: auto;
            }
        }
    }

    .subscribe-form__form {
        position: relative;
        input {
            background-color: #fff;
            &::placeholder {
                color: #bcbcc3;
                font-size: 16px;
            }
        }
    }

    .subscribe-form__button {
        position: absolute;
        top: 14px;
        right: 14px;
        height: 24px;
        &:after {
            content: "";
            @include center-absolute(-5px);
        }
        @include bp($bp-desktop-sm) {
            top: 19px;
        }
    }

    .subscribe-form__agreement {
        margin-top: 12px;
        font-size: 12px;
        font-weight: 500;
        line-height: 22px;
        a {
            color: #0083db;
            &:hover {
                text-decoration: underline;
            }
        }
    }

    .subscribe-form__success {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        font-size: 16px;
        line-height: 26px;
        color: var(--success);
        opacity: 0;
        background-color: #fff;
        padding: 14px 24px;
        white-space: nowrap;
        pointer-events: none;
    }
</style>
